import { Form, FormFieldType } from "../Form";

export class CreatePlanForm extends Form {
  protected definition = {
    name: { required: true, type: FormFieldType.Text }
  };
}
